import styled from 'styled-components';
import { NavLink } from 'reactstrap';
import theme from 'theme';
import KaratRight from 'icons/KaratRight';

export const Page = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: relative;
  height: 100%;
`;

export const StyledContainer = styled.div<{ flexDirection?: string }>`
  flex: 4;
  margin-top: 10px;
  position: relative;
  max-height: calc(100vh - 100px);
  overflow-x: clip;
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'column'};
`;

export const Header = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.colorSemiDarkGray6};
  display: flex;
  flex: none;
  font-size: 26px;
  font-weight: 600;
  padding-bottom: 10px;
`;

export const StyledNavLink = styled(NavLink)`
  color: #808080;
  padding: 0 7px;
  margin: 14px 0;

  &.active {
    border-left: 2px solid ${(props) => props.theme.colors.colorRoyalBlue};
    color: #4a4a4a;
    font-weight: bold;
  }
`;

export const FeatureHeader = styled.div<{
  isWhite?: boolean;
  headerStyle?: string;
}>`
  font-size: 17px;
  padding: 10px 12px;
  height: 50px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  background: ${({ isWhite }) =>
    isWhite ? theme.colors.colorPureWhite : theme.colors.colorTranslucentGray4};
  position: sticky;
  /* top: 0px; Uncomment if you want permission header to be sticky */
  z-index: 1;
  align-items: center;
  ${({ headerStyle }) => headerStyle};
`;

export const StyledKaratRight = styled(KaratRight)<{ isOpen: boolean }>`
  height: 13px;
  width: 13px;
  transition: 0.2s ease-in-out;
  margin-right: 6px;
  transform: ${({ isOpen }) => (!isOpen ? 'rotate(0deg)' : 'rotate(90deg)')};
`;

export const FeatureContainer = styled.div<{
  isOpen: boolean;
  headerContainerStyle?: string;
}>`
  padding: 0px;
  background: ${theme.colors.colorTranslucentGray4};
  border-bottom: 1px solid ${theme.colors.colorLightGray6};
  margin-bottom: 0px;
  &:hover {
    ${FeatureHeader}:hover {
      color: ${theme.colors.colorRoyalBlue};
      background: ${theme.colors.colorPureWhite};
      ${StyledKaratRight} {
        path {
          fill: ${theme.colors.colorRoyalBlue};
        }
      }
    }
  }
  ${({ headerContainerStyle }) => headerContainerStyle};
`;

export const CheckBoxOptionText = styled.div<{
  isHeader: boolean;
  isChecked: boolean;
  condensed: boolean;
}>`
  color: ${({ isChecked, isHeader }) =>
    isHeader
      ? '#000000'
      : isChecked
      ? theme.colors.colorSemiDarkGray1
      : theme.colors.colorMediumGray5};
  font-size: ${({ condensed }) => (condensed ? '14px' : '12px')};
  ${(props) =>
    props.isHeader &&
    `
    color: ${theme.colors.colorPureBlack};
    font-weight: 600;
  `}
  margin-left: 6px;
`;

export const CheckBoxOptionsContainer = styled.div<{
  condensed: boolean;
  hasCustomSubComponent: boolean;
}>`
  display: flex;
  align-items: ${({ hasCustomSubComponent }) =>
    hasCustomSubComponent ? 'flex-start' : 'center'};
  ${({ condensed }) =>
    condensed ? 'padding-bottom: 20px' : 'padding: 4px 0px'};
  position: relative;
`;

export const CheckBoxListItemsContainer = styled.ul<{ condensed: boolean }>`
  background: ${theme.colors.colorPureWhite};
  padding: ${({ condensed }) => (condensed ? '0px 20px' : '20px 44px')};
  margin: 0;
`;

export const CustomCheckBoxContainer = styled.div<{
  isDisabled: boolean;
  condensed: boolean;
  disableCursor: boolean;
}>`
  border-radius: 3px;
  border: 1px solid ${theme.colors.colorLightGray6};
  background: ${({ isDisabled }) =>
    isDisabled ? theme.colors.colorLightGray6 : 'transparent'};
  cursor: ${({ isDisabled, disableCursor }) =>
    isDisabled || disableCursor ? '' : 'pointer'};
  &:hover {
    border: ${({ isDisabled }) =>
      isDisabled ? '' : '1px solid ${theme.colors.colorMediumGray4'};
  }
  ${({ condensed }) => (condensed ? 'margin-top: 6px' : '')}
`;

export const CustomCheckBox = styled.div<{
  isChecked: boolean;
  isDisabled: boolean;
}>`
  margin: 2px;

  height: 12px;
  width: 12px;
  border-radius: 2px;
  background: ${({ isChecked, isDisabled }) =>
    isDisabled
      ? 'transparent'
      : isChecked
      ? theme.colors.colorRoyalBlue
      : theme.colors.colorPureWhite};
`;

export const HiddenInput = styled.input<{
  isDisabled: boolean;
  disableCursor: boolean;
}>`
  position: absolute;
  cursor: ${({ isDisabled, disableCursor }) =>
    isDisabled || disableCursor ? '' : 'pointer'};
  opacity: 0;
  width: 18px;
  height: 18px;
`;

export const DefaultTextContainer = styled.span`
  color: ${theme.colors.colorMediumGray3};
  font-size: 10px;
  margin-left: 6px;
`;

export const TooltipContainer = styled.span`
  margin-left: 5px;
`;

export const SubText = styled.div`
  color: #a4a4a4;
  font-size: 12px;
  position: absolute;
  top: 17px;
`;

export const CustomSubComponentContainer = styled.div`
  margin-top: 8px;
`;

export const RequiredText = styled.span`
  color: ${theme.colors.colorLightGray6};
`;

export const WhiteStripeLine = styled.div`
  position: absolute;
  width: 6px;
  height: 1px;
  left: 4px;
  top: 9.5px;
  background: ${theme.colors.colorPureWhite};
`;
